module.exports = __webpack_public_path__ + "media/post-registration/create-event@2x-4116014f.png";